import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=8041af78&scoped=true"
import script from "./Consignment.vue?vue&type=script&lang=js"
export * from "./Consignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8041af78",
  null
  
)

export default component.exports